import React from "react";

interface WrapperProps {
  entity: { id: string | number };
  children?: React.ReactNode;
  defaultValue: React.ReactNode;
  forAllRowsExceptRoot?: boolean;
}

const Wrapper: React.FC<WrapperProps> = ({
  entity,
  children,
  defaultValue,
  forAllRowsExceptRoot = false,
}) => {
  // this condition show edit icon for all rows except root
  if (forAllRowsExceptRoot && typeof entity.id === "number") {
    return <>{children}</>;
  }

  if ((entity.id as string | number).toString().startsWith("custom_group")) {
    return <>{children}</>;
  }

  return <>{defaultValue}</>;
};

export default Wrapper;
